import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Col, Row, Input } from 'reactstrap'
import { HasPermissionsQuery } from "../Functions/querys"
import ManagePlatesModal from "./ManagePlatesModal/ManagePlatesModal"
import UpdatePolicyModal from "./UpdatePolicyModal"
import updateFilters from "../Functions/updateFilters"
import withApolloClient from '../withApolloClient'
import AdvancedFiltersControl from '../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'

class CarsListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, [], this.props.navigate, this.props.location, this.props.setFilterValues)
    }
    render() {
        return (
            <Row className="mb-2">
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={8} className="text-right mt-2">
                    {this.state.openModal && this.state.openModal === "managePlatesModal" && <ManagePlatesModal handleClose={() => this.toggleModal("managePlatesModal")} open={this.state.openModal === "managePlatesModal"} />}
                    {this.state.openModal && this.state.openModal === "updatePolicyModal" && <UpdatePolicyModal handleClose={() => this.toggleModal("updatePolicyModal")} open={this.state.openModal === "updatePolicyModal"} />}
                    {this.props.hasPermissions && this.props.hasPermissions.includes("change_plate") && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("managePlatesModal")}>
                            <i className={"fa fa-exchange"}></i> Manage Plates
                        </a>
                        &nbsp;&nbsp;&nbsp;&nbsp; </>
                    }
                    {this.props.hasPermissions && this.props.hasPermissions.includes("change_carpolicy") && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("updatePolicyModal")}>
                            <i className={"fa fa-paper-plane-o"}></i> Update Policy
                        </a>
                        &nbsp;&nbsp;&nbsp;&nbsp; </>
                    }
                    <AdvancedFiltersControl entity="car" />
                </Col>
                <Col xs={12} className="mt-2">
                    {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedDrivers}></i> &nbsp;&nbsp; Selected Drivers</span>
                        {this.props.selectedDrivers.length}
                    </span>}
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters entity="car" context={null} />
                </Col>
            </Row>
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["change_plate", "change_carpolicy"] },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables
    })
})(
    withApolloClient(CarsListHeader)
)
